module.exports = __webpack_public_path__ + "static/media/logo--nl.6888af02.svg";